import type { ExamSchedule } from '@/types';
import { formatDate, formatDday } from '@/lib/datetime';

interface ParentExamScheduleSectionProps {
  schedules: ExamSchedule[];
}

const toneClass: Record<'past' | 'soon' | 'far', string> = {
  past: 'bg-background-200 text-foreground-500',
  soon: 'bg-accent-500 text-background-50',
  far: 'bg-primary-100 text-primary-700',
};

export default function ParentExamScheduleSection({ schedules }: ParentExamScheduleSectionProps) {
  return (
    <section className="rounded-xl border border-background-200 bg-background-50 p-5 md:p-6">
      <h2 className="flex flex-wrap items-center gap-2 text-sm font-bold text-foreground-950">
        <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
          <i className="ri-calendar-event-line"></i>
        </span>
        시험 일정
        <span className="rounded-full bg-background-200 px-2.5 py-0.5 text-[11px] font-semibold text-foreground-600">
          {schedules.length}건
        </span>
      </h2>

      {schedules.length === 0 ? (
        <p className="mt-4 rounded-lg border border-dashed border-background-300 py-8 text-center text-sm text-foreground-500">
          아직 등록된 시험 일정이 없어요.
        </p>
      ) : (
        <div className="mt-4 flex flex-col gap-2.5">
          {schedules.map((s) => {
            const dday = formatDday(s.end_date ?? s.start_date);
            return (
              <div key={s.id} className="rounded-lg border border-background-200 bg-background-100 p-4">
                <div className="flex flex-wrap items-center gap-2">
                  <p className="text-sm font-semibold text-foreground-950">{s.title}</p>
                  {dday && (
                    <span className={`rounded-full px-2.5 py-0.5 text-xs font-bold ${toneClass[dday.tone]}`}>
                      {dday.label}
                    </span>
                  )}
                </div>
                <p className="mt-1 flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-calendar-line"></i>
                  {formatDate(s.start_date)} ~ {formatDate(s.end_date)}
                </p>
                {s.scope && (
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">
                    <span className="font-medium text-foreground-700">범위 </span>
                    {s.scope}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
}